import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    FormGroup,
    FormHelperText,
    MenuItem,
    Select,
    SwipeableDrawer,
    InputAdornment,
} from '@material-ui/core';
import moment from 'moment';
import { useEffect, useState } from 'react';
import en from '../../../../lang/en-us';
import SearchInput from '../../../../lib/SearchInput';
import TextInput from '../../../../lib/TextField';
import { NOMINEE } from '../../../../redux-store/types/nct';
import { sendPhoneOTP, fetchIFSCDetails } from '../../../../redux-store/actions/nct';
import { NOMINEEINFO } from '../UpdateNominee/update-nominee-edit';
import {
    CorrectionFolioSelection,
    initSelection,
    validateName,
    validatePrimaryHolder,
} from './types';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import {
    getDateString,
    ifscRegex,
    isAlphaNumeric,
    minDateForCalender,
    OTP_ACTIONS,
    _minDateForCalender,
    DATA_ERROR,
} from '../../../../utils/constants';
import { ValidationUI } from '../MinorStatus/minor-status-edit-bank';
import DatePickerInput from '../../../../lib/DatePicker';
import { ActionHeader, FaqLink } from '..';
import { SubmitButtonWithLoader } from '../../../../lib/Button';
import { getTaxStatusCode } from '../../portfolios/utils';
const { dashboard, common, nctLinks } = en;

const payloadKeyValues: any = {
    investorName: 'firstHolder',
    secondaryHolderName: 'secondHolder',
    thirdHolderName: 'thirdHolder',
    guardian_name: 'guardian',
    mobile: 'mobile',
    dob: 'dob',
    taxStatus: 'taxStatus',
    modeOfHolding: 'modeOfHolding',
    email: 'email',
};

export const getNameIndex = (index: number) => {
    if (index === 1) {
        return '1st';
    } else if (index === 2) {
        return '2nd';
    } else if (index === 3) {
        return '3rd';
    }
};

function CorrectionFoliosSelection(props: any) {
    const { fund = null } = props.location.state || {};
    const [selection, setSelection] = useState<CorrectionFolioSelection<any>[]>(initSelection);
    const [selectedItems, setSelectedItems] = useState<CorrectionFolioSelection<any>[]>([]);
    const [nameFields, setNameFields] = useState<Array<string>>([
        dashboard.CorrectionFolios.Selection.Fields.primaryHolder,
        dashboard.CorrectionFolios.Selection.Fields.secondHolder,
        dashboard.CorrectionFolios.Selection.Fields.thirdHolder,
        dashboard.CorrectionFolios.Selection.Fields.guardianName,
    ]);
    const [openDrawer, setDrawer] = useState<boolean>(false);
    const [showLoader, setLoader] = useState<boolean>(false);
    const [ifscValidation, setValidation] = useState<boolean>(false);
    const [nomineesShare, setNomineesShare] = useState<any>([]);
    const [searchString, setSearch] = useState<string>('');
    const [error, setError] = useState<{ error: boolean; message: string }>({
        error: false,
        message: '',
    });
    const [validate, setValidate] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const ifscField = selectedItems.find(
        (_ele: CorrectionFolioSelection<any>) => _ele.field === 'bank_ifsc',
    );

    useEffect(() => {
        setLoader(false);
        if (ifscField?.newValue.length === 11) {
            document.getElementById('bank_ifsc')?.blur();
            checkForCorrectIFSC();
        }
    }, [ifscField?.newValue]);

    const nomineeNamesKey = (index: number) => {
        return `${index}_nominee_name`;
    };

    const nomineeSharesKey = (index: number) => {
        return `${index}_nominee_share`;
    };

    useEffect(() => {
        if (!fund) {
            props.history.push('/');
            return;
        }
        const nameFieldsOfNominee = fund.nominees.map(
            (_ele: NOMINEEINFO, index: number) => `Nominee ${index + 1} name`,
        );
        setNameFields([...nameFields, ...nameFieldsOfNominee]);
        const fundKeysByRowData = {
            ...fund,
            bank_ifsc: fund?.bank[0]?.ifsc,
            bank_accountNo: fund?.bank[0]?.accountNo,
            bank_accountType: fund?.bank[0]?.accountType,
            guardian_name: fund?.guardian?.name,
        };
        const nomineesNames = fund.nominees.reduce(
            (prev: any, curr: NOMINEEINFO, index: number) => {
                return {
                    ...prev,
                    [nomineeNamesKey(index)]: curr.name,
                };
            },
            {},
        );

        const nomineesShares = fund.nominees.reduce((prev: any, curr: NOMINEE, index: number) => {
            return {
                ...prev,
                [nomineeSharesKey(index)]: curr.percent,
            };
        }, {});

        const nomineesNamesData = fund.nominees
            .slice(0, 3)
            .map((_ele: NOMINEEINFO, index: number) => ({
                label: `${getNameIndex(index + 1)} Nominee name`,
                field: `${index}_nominee_name`,
                type: 'text',
                isSelected: false,
                newValue: '',
                validate: ({ value, newValue }: { value: string; newValue: string }) => {
                    if (newValue) {
                        return validateName(value, newValue);
                    }
                    return { error: false, helperText: '' };
                },
                handleChangeCondition: (newValue: any) => {
                    if (isAlphaNumeric(newValue) || !newValue) {
                        return true;
                    }
                },
            }));
        const nomineesShareData = fund.nominees
            .slice(0, 3)
            .map((_nominee: NOMINEEINFO, index: number) => ({
                label: `Share of Nominee ${index + 1} (in %)`,
                field: `${index}_nominee_share`,
                type: 'number',
                isSelected: false,
                isNominee: true,
                handleChangeCondition: (newValue: any) => {
                    if ((/^\d+$/.test(newValue) || !newValue) && Number(newValue) <= 100) {
                        return true;
                    }
                },
                newValue: '',
                validate: ({ value, newValue }: any) => {
                    if (newValue && Number(newValue) === 0) {
                        return { error: true, helperText: 'Share should not be zero' };
                    }
                    return { error: false, helperText: '' };
                },
            }));
        setNomineesShare(nomineesShareData);
        const updateKeysWithRowData = { ...fundKeysByRowData, ...nomineesNames, ...nomineesShares };
        const updatedSelections = [
            ...initSelection,
            ...nomineesNamesData,
            ...nomineesShareData,
        ].map((selector) => ({
            ...selector,
            value: updateKeysWithRowData[
                `${selector.field === 'taxStatus' ? 'taxStatusLabel' : selector.field}`
            ], // manupulating  taxStatus
        }));
        setSelection(updatedSelections);
    }, []);

    const _handleCheckBoxChange = (selector: CorrectionFolioSelection<any>, index: number) => {
        setSelectedItems((prevSelections) => {
            return selector.isSelected
                ? [...prevSelections, selector]
                : prevSelections.filter((_selector) => selector.label !== _selector.label);
        });

        setSelection((prevSelections) => {
            prevSelections[index] = selector;
            return prevSelections;
        });
        if (selector.isNominee) {
            setNomineesShare(
                nomineesShare.map((_ele: any) => {
                    if (_ele.field === selector.field) {
                        return {
                            ..._ele,
                            isSelected: !_ele.isSelected,
                        };
                    }
                    return _ele;
                }),
            );
        }
    };

    const handleTextInputChange = (value: any, label: string) => {
        setSelectedItems(
            selectedItems.map((_ele: CorrectionFolioSelection<any>) => {
                if (_ele.label === label) {
                    return {
                        ..._ele,
                        newValue: value,
                    };
                }
                return _ele;
            }),
        );
    };

    const checkIfShareIsSelected = () => {
        return nomineesShare.some((_ele: CorrectionFolioSelection<any>) => _ele.isSelected);
    };

    const handleSubmit = async () => {
        const { fund } = props.location.state;
        const nomineeIds = fund.nominees.slice(0, 3).map((_ele: NOMINEEINFO) => _ele.id);
        const keyValuePairs = selectedItems.reduce(
            (prev: any, curr: CorrectionFolioSelection<any>) => ({
                ...prev,
                [curr.field]: curr.newValue || '',
            }),
            {},
        );
        const selectedFieldPairs = selection.reduce(
            (prev: any, curr: CorrectionFolioSelection<any>) => ({
                ...prev,
                [curr.field]: '',
            }),
            {},
        );
        const correctedData = { ...selectedFieldPairs, ...keyValuePairs };
        const values: { [key: string]: string } = Object.keys(payloadKeyValues).reduce(
            (prev, curr: any) => ({
                ...prev,
                [payloadKeyValues[curr]]: correctedData[curr],
            }),
            {},
        );
        const updatedNominees = nomineeIds.length
            ? nomineeIds.map((_ele: string, index: number) => ({
                id: _ele,
                name: correctedData[`${index}_nominee_name`],
                percent: correctedData[`${index}_nominee_share`],
            }))
            : [{ id: 1, name: '', percent: '' }];
        if (checkIfShareIsSelected()) {
            const totalShare = updatedNominees
                .map((_ele: any) => _ele.percent)
                .reduce((sum: number = 0, current: number) => sum + Number(current), 0);
            if (totalShare < 100) {
                alert('Total Share is less than 100 %');
                return;
            }
            if (totalShare > 100) {
                alert('Total Share is greater than 100 %');
                return;
            }
        }
        const data = {
            folio: fund?.folio,
            amc: fund?.amc,
            ...values,
            taxStatus:
                Object.keys(getTaxStatusCode).find(
                    (_ele: any) => getTaxStatusCode[_ele] === values.taxStatus,
                ) || '',
            bank: {
                accountNo: correctedData['bank_accountNo'],
                accountType: correctedData['bank_accountType'],
                ifsc: correctedData['bank_ifsc'],
            },
            dob: getDateString(correctedData['dob']),
            nominees: updatedNominees,
            dpId: '',
        };
        const { pan = '', pekrn = '', mobile = '' } = props;
        try {
            setLoading(true);
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.correctionFolios,
            });
            props.history.replace('correction-folios-otp', {
                mobile: props.mobile,
                pan: props.pan,
                amc: fund.amc,
                data,
                ...(res || {}).body,
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    const checkForCorrectIFSC = async () => {
        setValidation(true);
        setLoader(true);
        let ifsc = (
            selectedItems.find(
                (_ele: CorrectionFolioSelection<any>) => _ele.field === 'bank_ifsc',
            ) || {}
        ).newValue;
        if (ifsc.match(ifscRegex)) {
            const { pan, pekrn, mobile, reqId } = props;
            try {
                let response: any = await props.fetchIFSCDetails({
                    pan,
                    pekrn,
                    mobile,
                    reqId,
                    ifscCode: ifsc,
                });
                const { errors = [], data = [] } = (response || {}).body;
                if (errors.length) {
                    const [firstError] = errors;
                    throw Error(firstError?.message);
                }
                setValidation(false);
                setError({
                    error: false,
                    message: '',
                });
            } catch (e: any) {
                setLoader(false);
                setValidation(false);
                setError({ error: true, message: e.message });
            }
        } else {
            setLoader(false);
            setValidation(false);
            setError({ error: true, message: common.errors.bankErrors.ifsc.regex });
        }
    };

    const handleSearch = (selections: CorrectionFolioSelection<any>[]) => {
        if (searchString) {
            return selections.filter((_ele: CorrectionFolioSelection<any>) =>
                _ele.label.toLowerCase().includes(searchString.toLowerCase()),
            );
        }
        return selections;
    };

    const getNames = (
        selectorKey: string,
        keyList: Array<string>,
        updatedValue: string,
        oldValue: string,
    ) => {
        if (updatedValue) {
            const filteredNames = keyList.filter((_ele: string) => _ele !== selectorKey);
            const namesData = selectedItems
                .map((_ele: CorrectionFolioSelection<any>) => {
                    if (filteredNames.includes(_ele.label)) {
                        return _ele.newValue.trim().toLowerCase();
                    }
                })
                .filter((ele) => ele);
            if (selectorKey.match('Primary Holder Name')) {
                if (validatePrimaryHolder(oldValue, updatedValue).error) {
                    return validatePrimaryHolder(oldValue, updatedValue);
                }
            } else {
                if (validateName(oldValue, updatedValue).error) {
                    return validateName(oldValue, updatedValue);
                }
            }
            if (namesData.includes(updatedValue.trim().toLowerCase())) {
                return {
                    error: true,
                    helperText: `${selectorKey} should not be same as other names`,
                };
            }
            return { error: false, helperText: '' };
        }
        return { error: false, helperText: '' };
    };

    const isButtonDisabled = () => {
        return selectedItems.some((_ele: CorrectionFolioSelection<any>) => {
            if (nameFields.includes(_ele.label)) {
                return getNames(_ele.label, nameFields, _ele.newValue, _ele.value).error;
            }
            return false;
        });
    };

    const dataSelection = () => {
        return (
            <div className="correction-folios-left">
                <div className="correction-folios-search">
                    <h6> {dashboard.CorrectionFolios.Selection.selectionInfo}</h6>
                    <SearchInput
                        darkmode={true}
                        placeholder={dashboard.CorrectionFolios.Selection.search}
                        value={searchString}
                        onChange={({ target: { value } }: any) => setSearch(value)}
                        endAdornment={
                            searchString.length > 0 ? (
                                <InputAdornment position="end">
                                    <img
                                        style={{ cursor: 'pointer', width: '11px' }}
                                        src="/images/close-black.svg"
                                        alt="close-icon"
                                        onClick={() => setSearch('')}
                                    />
                                </InputAdornment>
                            ) : null
                        }
                    />
                    <div
                        role="status"
                        aria-live="polite"
                        aria-atomic="true"
                        style={{
                            position: 'absolute',
                            left: '-10000px',
                            width: '1px',
                            height: '1px',
                            overflow: 'hidden'
                        }}
                    >
                        {handleSearch(selection).length} {handleSearch(selection).length === 1 ? 'result' : 'results'} found
                    </div>
                </div>
                <div className="correction-folios-checkboxes">
                    <FormGroup>
                        {!!handleSearch(selection).length ? (
                            handleSearch(selection).map((selector, index: number) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            onChange={(e, checked) =>
                                                _handleCheckBoxChange(
                                                    {
                                                        ...selector,
                                                        isSelected: checked,
                                                    },
                                                    index,
                                                )
                                            }
                                            checked={selector.isSelected}
                                            name="primary-holder"
                                        />
                                    }
                                    label={selector.label}
                                />
                            ))
                        ) : (
                            <p
                                style={{
                                    fontSize: 14,
                                    lineHeight: '24px',
                                    color: '#4f4f4f',
                                    textAlign: 'center',
                                    background: '#fff',
                                    padding: 20,
                                }}
                            >
                                {nctLinks.notMatched}
                            </p>
                        )}
                    </FormGroup>
                </div>
                <div className="correction-folios-apply mobile_mode">
                    <a onClick={() => setDrawer(false)}>Done</a>
                </div>
            </div>
        );
    };

    useEffect(() => {
        setSearch('');
    }, [openDrawer]);

    return (
        <div className="curved-bg correction-folios-screen">
            <ActionHeader header={dashboard.CorrectionFolios.CorrectionFoliosHeading} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table correction-folios-selection">
                    {dataSelection()}
                    <div className="mobile-correction-left mobile_mode">
                        <SwipeableDrawer
                            anchor={'bottom'}
                            open={openDrawer}
                            onClose={() => setDrawer(false)}
                            onOpen={() => setDrawer(true)}
                        >
                            {dataSelection()}
                        </SwipeableDrawer>
                    </div>
                    <div className="mobile_mode correction-filters-btn">
                        <a onClick={() => setDrawer(true)}>Add/Remove Correction</a>
                    </div>
                    <div className="correction-folios-right">
                        <div className="correction-right-top">
                            <p>
                                {dashboard.CorrectionFolios.Selection.selectedFolio}
                                <span>{fund?.folio}</span>
                            </p>
                            <p>
                                {dashboard.CorrectionFolios.Selection.amc}
                                <span>{fund?.amcName}</span>
                            </p>
                        </div>
                        <div className="correction-right-bottom">
                            {/* <div className="correction-selected-empty">
                                <p>{dashboard.CorrectionFolios.Selection.makeSelection}</p>
                            </div> */}
                            {!!selectedItems.length ? (
                                <div className="correction-right-lists">
                                    {selectedItems.map((selector, index: number) => (
                                        <div key={index} className="correction-right-info">
                                            <h5>{selector.label}</h5>
                                            <div className="correction-right-info-txt">
                                                <h5>
                                                    {
                                                        dashboard.CorrectionFolios.Selection
                                                            .nameInRecords
                                                    }
                                                    {selector.type === 'dob' ? (
                                                        moment(selector.value).format('DD/MM/YYYY')
                                                    ) : (
                                                        <span>
                                                            {selector.value || 'Not Available'}
                                                        </span>
                                                    )}
                                                </h5>
                                                {[
                                                    'bank_accountType',
                                                    'taxStatus',
                                                    'modeOfHolding',
                                                ].includes(selector.field) ? (
                                                    <FormControl
                                                        variant="outlined"
                                                        error={
                                                            validate
                                                                ? selector.validate &&
                                                                selector.validate({
                                                                    value: selector.value,
                                                                    newValue: selector.newValue,
                                                                }).error
                                                                : false
                                                        }
                                                    >
                                                        <Select
                                                            labelId="complaint-amc-label"
                                                            id="complaint-amc"
                                                            value={selector.newValue || 'Select'}
                                                            onChange={({ target: { value } }) =>
                                                                handleTextInputChange(
                                                                    value,
                                                                    selector.label,
                                                                )
                                                            }
                                                            onBlur={() => setValidate(true)}
                                                        >
                                                            <MenuItem value="Select">
                                                                SELECT
                                                            </MenuItem>
                                                            {selector.masterData?.map(
                                                                (_ele: string) => (
                                                                    <MenuItem value={_ele}>
                                                                        {_ele}
                                                                    </MenuItem>
                                                                ),
                                                            )}
                                                        </Select>
                                                        <FormHelperText>
                                                            {validate
                                                                ? selector.validate &&
                                                                selector.validate({
                                                                    value: selector.value,
                                                                    newValue: selector.newValue,
                                                                }).helperText
                                                                : ''}
                                                        </FormHelperText>
                                                    </FormControl>
                                                ) : selector.type === 'dob' ? (
                                                    <DatePickerInput
                                                        id={'dob'}
                                                        label={dashboard.UpdateForm15.Income.dob}
                                                        value={selector.newValue}
                                                        onChange={(date) => {
                                                            handleTextInputChange(
                                                                date,
                                                                selector.label,
                                                            );
                                                        }}
                                                        minDate={_minDateForCalender()}
                                                        maxDate={moment(new Date()).format(
                                                            'YYYY-MM-DD',
                                                        )}
                                                        error={
                                                            validate
                                                                ? selector.validate &&
                                                                selector.validate({
                                                                    value: selector.value,
                                                                    newValue: selector.newValue,
                                                                }).error
                                                                : false
                                                        }
                                                        helperText={
                                                            validate
                                                                ? selector.validate &&
                                                                selector.validate({
                                                                    value: selector.value,
                                                                    newValue: selector.newValue,
                                                                }).helperText
                                                                : ''
                                                        }
                                                    />
                                                ) : (
                                                    <FormControl variant="outlined">
                                                        <TextInput
                                                            style={{
                                                                width: '100%',
                                                            }}
                                                            label={selector.label}
                                                            variant="outlined"
                                                            type={'text'}
                                                            id={selector.field}
                                                            value={
                                                                selector.field === 'bank_ifsc'
                                                                    ? selector.newValue.toUpperCase()
                                                                    : selector.newValue
                                                            }
                                                            name={selector.field}
                                                            inputProps={{
                                                                max: moment(new Date()).format(
                                                                    'YYYY-MM-DD',
                                                                ),
                                                                min: minDateForCalender(),
                                                                maxlength:
                                                                    selector.field ===
                                                                        'guardian_name'
                                                                        ? '60'
                                                                        : '',
                                                            }}
                                                            onChange={({ target: { value } }) => {
                                                                if (
                                                                    selector.handleChangeCondition
                                                                ) {
                                                                    selector.handleChangeCondition(
                                                                        value,
                                                                    )
                                                                        ? handleTextInputChange(
                                                                            value,
                                                                            selector.label,
                                                                        )
                                                                        : null;
                                                                    return;
                                                                }
                                                                handleTextInputChange(
                                                                    value,
                                                                    selector.label,
                                                                );
                                                            }}
                                                            onBlur={() => {
                                                                if (
                                                                    selector.field === 'bank_ifsc'
                                                                ) {
                                                                    setError({
                                                                        error: true,
                                                                        message: '',
                                                                    });
                                                                    checkForCorrectIFSC();
                                                                }
                                                                setValidate(true);
                                                            }}
                                                            onFocus={() => setValidate(false)}
                                                            error={
                                                                validate
                                                                    ? selector.field === 'bank_ifsc'
                                                                        ? error.error
                                                                        : nameFields.includes(
                                                                            selector.label,
                                                                        )
                                                                            ? getNames(
                                                                                selector.label,
                                                                                nameFields,
                                                                                selector.newValue,
                                                                                selector.value,
                                                                            ).error
                                                                            : selector.validate &&
                                                                            selector.validate({
                                                                                value: selector.value,
                                                                                newValue:
                                                                                    selector.newValue,
                                                                            }).error
                                                                    : false
                                                            }
                                                            helperText={
                                                                validate
                                                                    ? selector.field === 'bank_ifsc'
                                                                        ? error.message
                                                                        : nameFields.includes(
                                                                            selector.label,
                                                                        )
                                                                            ? getNames(
                                                                                selector.label,
                                                                                nameFields,
                                                                                selector.newValue,
                                                                                selector.value,
                                                                            ).helperText
                                                                            : selector.validate &&
                                                                            selector.validate({
                                                                                value: selector.value,
                                                                                newValue:
                                                                                    selector.newValue,
                                                                            }).helperText
                                                                    : ''
                                                            }
                                                        />
                                                        {selector.shouldValidateField &&
                                                            showLoader && (
                                                                <FormHelperText>
                                                                    <ValidationUI
                                                                        isValidating={
                                                                            ifscValidation
                                                                        }
                                                                        onValidationText={
                                                                            common.validatingIFSC
                                                                        }
                                                                        successfulValidationText={
                                                                            common.IFSCValidated
                                                                        }
                                                                    />
                                                                </FormHelperText>
                                                            )}
                                                    </FormControl>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div className="correction-selected-empty">
                                    <p className="desktop_mode">
                                        {dashboard.CorrectionFolios.Selection.makeSelection}
                                    </p>
                                    <p className="mobile_mode">
                                        {dashboard.CorrectionFolios.Selection.makeSelectionMobile}
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="correction-right-btn">
                            {!!selectedItems.length && (
                                <SubmitButtonWithLoader
                                    className="customBtn"
                                    disabled={
                                        !selectedItems.length ||
                                        !selectedItems.every(
                                            (_ele: CorrectionFolioSelection<any>) =>
                                                !!_ele.newValue,
                                        ) ||
                                        selectedItems.some(
                                            (_ele: CorrectionFolioSelection<any>) => {
                                                if (_ele.validate) {
                                                    return _ele.validate({
                                                        value: _ele.value,
                                                        newValue: _ele.newValue,
                                                    }).error;
                                                }
                                                return false;
                                            },
                                        ) ||
                                        error.error ||
                                        isButtonDisabled()
                                    }
                                    onClick={handleSubmit}
                                    label={dashboard.CorrectionFolios.Selection.buttonText}
                                    loading={loading}
                                    labelWhileLoading={dashboard.OtpScreen.buttonTextWhileLoading}
                                ></SubmitButtonWithLoader>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <FaqLink section={DATA_ERROR} history={props.history} />
        </div>
    );
}

export default connect(
    ({ authReducer, portfolio }: RootStateType) => ({ ...authReducer, ...portfolio }),
    { sendPhoneOTP, fetchIFSCDetails },
)(CorrectionFoliosSelection);
